import React from 'react'
import { compose, withProps } from 'recompose'
import { refElements } from './elementUtils'
import withElementIntl from './withElementIntl'
import withScreen from './withScreen'

const styleSelect = ({ height, width }) => ({
  height: height === '100%' ? '100%' : '',
  width: width === '100%' ? '100%' : '',
})

const withRender = (ElementBar, ElementSelector) => compose(
  withScreen(),
  withElementIntl(),
  withProps(
    ({
      parentId,
      element: {
        id: elementId,
        refElement,
        elements = [],
        ...props
      },
      screen,
      currentLang,
      parents,
      api,
      EnhancedSwitcher,
    }) => ({
      refElement,
      screen,
      currentLang,
      ...props,
      renderElement: (Component, props) => (ElementBar && refElement !== refElements.COLUMN ?
        <ElementBar
          refElement={refElement}
          elementId={elementId}
          parentId={parentId}
          parents={parents}
          style={props ? styleSelect({ height: props.style.height, width: props.style.width }) : {}}
        >
          <div
            style={props ?
              styleSelect({ height: props.style.height, width: props.style.width })
              :
              {}
            }
          >
            <Component {...props} />
          </div>
        </ElementBar>
        :
        <Component {...props} />
      ),
      renderChildren: () => {
        const { defaultContent, deviceContent } = props
        const defaultGutter = refElements.COLUMNS ? defaultContent : {}
        const deviceGutter = refElements.COLUMNS ? deviceContent : {}
        const inactiveChildren = refElement === refElements.COLUMNS
        const upperParentId = refElement === refElements.COLUMN ? parentId : null
        if (!ElementBar) {
          // for withContextElement
          return elements.map((id) => (
            <EnhancedSwitcher
              key={id}
              api={api}
              elementId={id}
              defaultGutter={defaultGutter}
              deviceGutter={deviceGutter}
              EnhancedSwitcher={EnhancedSwitcher}
            />
          ))
        }
        // for Columns
        return inactiveChildren ? (
          elements.map((id) => (
            <EnhancedSwitcher
              key={id}
              api={api}
              elementId={id}
              parentId={elementId}
              parents={[
                { id: elementId, refElement },
                ...parents,
              ]}
              defaultGutter={defaultGutter}
              deviceGutter={deviceGutter}
              EnhancedSwitcher={EnhancedSwitcher}
            />
          ))
        ) : (
        // for withReduxElement
          [
            ...elements.map((id, i) => (
              [
                <ElementSelector
                  key={`${id}-element-selector`}
                  refElement={refElement}
                  selectorId={id}
                  parentId={elementId}
                  elementIndex={i}
                  upperParentId={upperParentId} // for COLUMN
                />,
                <EnhancedSwitcher
                  key={id}
                  api={api}
                  screen={screen}
                  elementId={id}
                  parentId={elementId}
                  parents={
                    refElement === refElements.COLUMN ?
                      parents
                      :
                      [
                        { id: elementId, refElement },
                        ...parents,
                      ]
                  }
                  EnhancedSwitcher={EnhancedSwitcher}
                  defaultGutter={defaultGutter}
                  deviceGutter={deviceGutter}
                />,
              ]
            )),
            <ElementSelector
              key="element-selector"
              emptyMode={elements.length === 0}
              refElement={refElement}
              selectorId={elementId}
              parentId={elementId}
              elementIndex={elements.length}
              upperParentId={upperParentId} // for COLUMN
            />,
          ]
        )
      },
    }),
  ),
)

export default withRender



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/utils/withRender.js